import BackArrowIcon from './BackArrowIcon';

export default BackArrowIcon;
